import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Send = forwardRef(({ color = "currentColor", size = 24, ...rest }, ref) => {
    const defaultAttrs = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color,
        ref,
        ...rest,
    };
    return (_jsx("svg", { ...defaultAttrs, children: _jsx("path", { clipRule: "evenodd", d: "m21.7071 2.29292c.2742.27416.3651.68208.2335 1.04675l-6.5 18.00003c-.0095.026-.0199.0517-.0315.0769-.1236.2698-.3222.4985-.5719.6588-.2498.1603-.5404.2455-.8372.2455s-.5874-.0852-.8371-.2455c-.2438-.1565-.4388-.3781-.563-.6395l-3.34525-6.6905-6.69052-3.3453c-.26143-.1241-.48301-.3191-.63948-.5629-.1603-.2498-.24551-.5404-.24551-.8372 0-.29677.08521-.58733.24551-.83712.1603-.24978.38894-.4483.65876-.57194.02521-.01155.05088-.02205.07695-.03147l18.00004-6.5c.3646-.13168.7726-.04071 1.0467.23345zm-10.4903 11.90458 2.7154 5.4308 4.6043-12.75058zm5.9055-8.73399-12.75053 4.60439 5.43079 2.7154z", fill: "currentColor", fillRule: "evenodd" }) }));
});
Send.displayName = "Send";
//# sourceMappingURL=Send.js.map